







import { Component, Vue, Prop } from "vue-property-decorator";
import { Sketch } from 'vue-color'
@Component({
  name: "ColorPciker",
   components: {
    Sketch
  },
})
export default class ColorPciker extends Vue {
    @Prop({
      default: "#ffffff"
    }) value:any
    isShowColorPicker = false
    show() {
        this.isShowColorPicker = true
    }
    hide() {
        this.isShowColorPicker = false
    }
    onInput(color:any) {
      this.$emit('input', color)
    }
    
}
